//
// Module for the MemberDirect FAQ edit view
//
rs.module("content/system/configuration/memberdirectbroadcastmessages/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {
        // initialize the module
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {
            var currentFilter = $.js(jsSelectors.currentFilter);
            var messageAsOfDate = currentFilter.js(jsSelectors.messageAsOfDate);
            var messageLoadingSpinner = currentFilter.js(jsSelectors.messageLoadingSpinner);
            var addButton = $.js(jsSelectors.addButton);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            messageAsOfDate.find("input").on('click', function () {
                messageLoadingSpinner.show();

                // Update grid
                gridModule.update(
                    ajaxUrl,

                    { currentOnly: messageAsOfDate.find("input:checked").val() },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        messageLoadingSpinner.hide();

                        // Update the Add button url to include the current selection
                        addButton.attr('href', gridUpdate.context.addUrl);
                    }
                );
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);